module.exports = __webpack_public_path__ + "img/IT0001110446240.916dc211.png";